import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import InputSearch from "../../components/InputSearch/InputSearch";
import {
  Grid,
  makeStyles,
  createStyles,
  Button,
  Hidden,
  Tooltip,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  TableContainer,
  TableHead,
  TableBody,
  Typography,
  IconButton,
  Fab,
  Avatar,
} from "@material-ui/core";
import { Add } from "@material-ui/icons";
import {
  StyledTable,
  StyledTableCell,
  StyledTableRow,
} from "../../components/CustomStyles/CustomTable";
import Skeleton from "@material-ui/lab/Skeleton";
import CreateIcon from "@material-ui/icons/Create";

// add data
import { showForm } from "./parts/form";
import PickupStore from "../../Store/PickupStore";
import Img from "../../components/Img";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: "100%",
    },
    button: {
      margin: 0,
      maxHeight: 30,
      padding: 1,
    },
    paper: {
      padding: 8,
      width: 290,
    },
    demo1: {
      backgroundColor: theme.palette.background.paper,
      marginBottom: 10,
    },
    fab: {
      position: "fixed",
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    card: {
      margin: 5,
      width: "300px",
    },
    cardTitle: {
      color: theme.palette.primary.dark,
      fontWeight: "bolder",
    },
    cardSubHeader: {
      fontSize: "smaller",
    },
  })
);

const user = JSON.parse(localStorage.getItem("user"));

const PickupPointList = (props) => {
  const classes = useStyles();
  const { data, showDetail, handleShowForm } = props;

  return (
    <StyledTableRow>
      <StyledTableCell align="left">
        <List style={{ padding: 0 }}>
          <ListItem style={{ padding: 0 }}>
            <ListItemAvatar>
              <Avatar
                variant="rounded"
                style={{
                  boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.15)",
                  width: 80,
                  height: 45,
                  marginRight: 12,
                }}
              >
                <Img src={data.image_url} width={80} height={45} />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography
                  color="primary"
                  style={{ fontWeight: "bolder", fontSize: 13 }}
                >
                  {data.name}
                </Typography>
              }
            />
          </ListItem>
        </List>
      </StyledTableCell>
      <StyledTableCell align="left">
        <Typography color="textPrimary" style={{ fontSize: 12 }}>
          {data.type === "customer" ? "Customer" : "Courier"}
        </Typography>
      </StyledTableCell>
      {user?.operational?.level > 1 && (
        <StyledTableCell align="left">
          <Typography color="textPrimary" style={{ fontSize: 12 }}>
            {data.property.name}
          </Typography>
        </StyledTableCell>
      )}
      <StyledTableCell align="left">
        <Typography color="textPrimary" style={{ fontSize: 12 }}>
          {data.description}
        </Typography>
      </StyledTableCell>
      <StyledTableCell align="left">
        <Typography color="textPrimary" style={{ fontSize: 12 }}>
          Floor: {data?.floor || ""}
          <br />
          Coordinate: <a href={`https://www.google.com/maps/search/?api=1&query=${data.latitude},${data.longitude}`} target="_blank">[{data?.latitude || "-"}, {data?.longitude || "-"}]</a>
        </Typography>
      </StyledTableCell>
      <StyledTableCell align="right">
        {props.access.update && (
          <IconButton
            color="secondary"
            aria-label="detail property"
            onClick={() => props.doEdit(data)}
          >
            <CreateIcon style={{ color: "#757575" }} />
          </IconButton>
        )}
      </StyledTableCell>
    </StyledTableRow>
  );
};

const PickupPoint = (props) => {
  const classes = useStyles();
  const { params } = props;
  const [search, setSearch] = React.useState("");
  const [pickupState, pickupActions] = PickupStore();
  let perPage = 10;

  const handleGetPickupPointList = (refresh) => {
    var query = {
      num: perPage.toString(),
      cursor: pickupState.header["x-cursor"] || "",
      keyword: search,
    };
    pickupActions.getList(query, refresh);
  };

  const handleSearch = async (e) => {
    setSearch(e.target.value);
  };

  const handleShowForm = (value) => {
    if (value === null) {
      showForm("Add Pickup Point", value, handleGetPickupPointList).then(
        (process) => {
          // handleActions(value);
        },
        (cancel) => {
          // setUpdate(!update);
        }
      );
    } else {
      showForm("Edit Pickup Point", value, handleGetPickupPointList).then(
        (process) => {
          // handleActions(value);
        },
        (cancel) => {
          // setUpdate(!update);
        }
      );
    }
  };

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      const refresh = true;
      handleGetPickupPointList(refresh);
    }, 500);

    return () => clearTimeout(timeout);
  }, [search]);

  return (
    <BaseLayout>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <h3>Property / Pickup Point</h3>
        </Grid>
      </Grid>

      <Grid container className={classes.root}>
        <Grid
          item
          container
          direction="row"
          alignItems="flex-start"
          justify="space-between"
          xs={12}
        >
          <InputSearch
            value={search}
            onChange={(e) => {
              handleSearch(e);
            }}
            placeholder="Search"
          />
          <Hidden xsDown implementation="css">
            {props.params.create && (
              <Tooltip
                title="add property"
                aria-label="add"
                arrow
                placement="bottom"
              >
                <Button
                  onClick={() => handleShowForm(null)}
                  color="secondary"
                  variant="contained"
                >
                  <Add style={{ marginRight: "0.5rem" }} /> Add
                </Button>
              </Tooltip>
            )}
          </Hidden>
        </Grid>

        {/* table */}
        <Grid item xs={12}>
          <TableContainer>
            <StyledTable>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left">Name</StyledTableCell>
                  {user?.operational?.level > 1 && (
                    <StyledTableCell align="left">Property</StyledTableCell>
                  )}
                  <StyledTableCell align="left">Type</StyledTableCell>
                  <StyledTableCell align="left">Description</StyledTableCell>
                  <StyledTableCell align="left">Location</StyledTableCell>
                  <StyledTableCell></StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {pickupState.isLoading &&
                  Array.from(new Array(5)).map((row, key) => {
                    return (
                      <StyledTableRow key={key}>
                        <StyledTableCell align="left">
                          <List style={{ padding: 0 }}>
                            <ListItem style={{ padding: 0 }}>
                              <ListItemAvatar style={{ marginRight: 12 }}>
                                <Skeleton
                                  variant="rect"
                                  width={80}
                                  height={45}
                                />
                              </ListItemAvatar>
                              <ListItemText
                                primary={<Skeleton variant="text" width={90} />}
                              />
                            </ListItem>
                          </List>
                        </StyledTableCell>
                        {user?.operational?.level > 1 && (
                          <StyledTableCell align="left">
                            <Skeleton variant="text" width={120} />
                          </StyledTableCell>
                        )}
                        <StyledTableCell align="left">
                          <Skeleton variant="text" width={120} />
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <Skeleton variant="text" width={120} />
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <Skeleton variant="text" width={120} />
                        </StyledTableCell>
                        <StyledTableCell align="right"></StyledTableCell>
                      </StyledTableRow>
                    );
                  })}

                {!pickupState.isLoading &&
                  pickupState.data.map((pickup) => {
                    return (
                      <PickupPointList
                        key={pickup.id}
                        data={pickup}
                        access={props.params}
                        doEdit={() => {
                          handleShowForm(pickup);
                        }}
                      />
                    );
                  })}
              </TableBody>
            </StyledTable>
          </TableContainer>
        </Grid>
        {/* table end */}
        {/* no data */}
        {!pickupState.isLoading && pickupState.data.length === 0 && (
          <Grid item xs={12}>
            <div className={classes.demo1}>
              <Grid
                item
                xs
                container
                justify="center"
                style={{ margin: 10, padding: 12 }}
              >
                <span>No Data</span>
              </Grid>
            </div>
          </Grid>
        )}
        {/* no data end */}
        {/* page > 10 */}
        {pickupState.data.length >= perPage && (
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            style={{ padding: "10px" }}
          >
            {pickupState.lastPage ? (
              <h2>~</h2>
            ) : (
              <Button
                onClick={() => handleGetPickupPointList(false)}
                size="small"
                color="secondary"
                variant="contained"
                disabled={pickupState.isLoading}
              >
                {pickupState.isLoading ? "Please Wait" : "Load More"}
              </Button>
            )}
          </Grid>
        )}
        <Hidden smUp implementation="css">
          {props.params.create && (
            <Tooltip
              title="add property"
              aria-label="add"
              arrow
              placement="left"
            >
              <Fab
                aria-label="Add"
                classes={{ root: "FabMobile" }}
                className={classes.fab}
                color="primary"
                onClick={() => handleShowForm(null)}
              >
                <Add />
              </Fab>
            </Tooltip>
          )}
        </Hidden>
        {/* page > 10 end */}
      </Grid>
    </BaseLayout>
  );
};

export default PickupPoint;
